module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAxklEQVQ4T+3TLQ4CMRAF4PcOgOACCCRiFacgKAQH4AIILgAaj0aDJNwCCWg0Hv3IbqakQLfdJiu3rk3ny/y0RMuLLXvowPyOShqRvLvITw8lDQEcSI5zWElXAHOHfg1F0hrAtCkq6QVgS7KMq9bflA1dkuzHMpX0BLDzsSBYHhq6ItkLoZIeAPa/WC3ooQuSAx+VdANwDGFR0ENnJAvbXwCcSG7q2pH8KVb+xIBzDEtm6LIwVCmsMZjzLpMl52BdhrndCt9/AyRSRBWkoDKZAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home/down.png
// module id = ANUN
// module chunks = 0